// ThemeContext.js — Sistem Dark/Light Mode
// - Default: ikuti settingan sistem device
// - User bisa override manual via toggle di Profil
// - Pilihan disimpan di localStorage

import React, { createContext, useContext, useState, useEffect } from 'react';

const STORAGE_KEY = 'temaApp';
const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [tema, setTemaState] = useState(null); // null = belum load

  useEffect(() => {
    const tersimpan = localStorage.getItem(STORAGE_KEY);
    if (tersimpan === 'light' || tersimpan === 'dark') {
      setTemaState(tersimpan);
      document.documentElement.setAttribute('data-theme', tersimpan);
    } else {
      // Ikuti sistem device
      const systemDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      const temaAwal = systemDark ? 'dark' : 'light';
      setTemaState(temaAwal);
      document.documentElement.setAttribute('data-theme', temaAwal);
    }

    // Listen perubahan sistem
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      const tersimpanSekarang = localStorage.getItem(STORAGE_KEY);
      if (!tersimpanSekarang) {
        const temaSystem = e.matches ? 'dark' : 'light';
        setTemaState(temaSystem);
        document.documentElement.setAttribute('data-theme', temaSystem);
      }
    };
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  const setTema = (temaBaru) => {
    localStorage.setItem(STORAGE_KEY, temaBaru);
    setTemaState(temaBaru);
    document.documentElement.setAttribute('data-theme', temaBaru);
  };

  const resetKeSystem = () => {
    localStorage.removeItem(STORAGE_KEY);
    const systemDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const temaSystem = systemDark ? 'dark' : 'light';
    setTemaState(temaSystem);
    document.documentElement.setAttribute('data-theme', temaSystem);
  };

  const isDark = tema === 'dark';

  return (
    <ThemeContext.Provider value={{ tema, isDark, setTema, resetKeSystem }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme harus dipakai di dalam ThemeProvider');
  return ctx;
}
